import axios from "axios";

import { IP_RESTRICTIONS_ENGINE_BASE_URL } from "../constants";

const ipRestrictionUrl = `${IP_RESTRICTIONS_ENGINE_BASE_URL}/ip_restriction`;

const update = params =>
  axios.patch(ipRestrictionUrl, { ipRestriction: params });

const show = () => axios.get(ipRestrictionUrl);

const ipRestrictionApi = { update, show };

export default ipRestrictionApi;
